import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';

const milestones = [
  { year: '2023年', title: '平台创立', desc: '青青草视频正式上线，致力于打造优质影视聚合平台，为用户提供一站式的免费高清观影体验。' },
  { year: '2023年', title: '首批合作', desc: '与香蕉视频、红桃视频达成战略合作，整合双方优质内容资源，平台影视库迅速扩充至1000+部。' },
  { year: '2024年', title: '快速发展', desc: '陆续接入91视频、蜜桃视频、樱花视频等平台，月活跃用户突破50万，成为行业领先的影视聚合平台。' },
  { year: '2024年', title: '技术升级', desc: '全面升级CDN加速和智能推荐系统，实现99.9%的播放成功率，用户体验大幅提升。' },
  { year: '2025年', title: '生态完善', desc: '接入糖豆视频、樱桃视频，完成八大平台聚合。推出个性化推荐和智能分类功能，日活用户突破百万。' },
];

const testimonials = [
  {
    name: '张先生',
    role: '资深影迷',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20asian%20man%20in%20his%2030s%2C%20friendly%20expression%2C%20clean%20simple%20background%2C%20headshot%20photography%2C%20warm%20natural%20lighting&width=100&height=100&seq=avatar-01&orientation=squarish',
    text: '青青草视频真的太方便了！以前要切换好几个APP找电影，现在一个网站就能看遍各大平台的热门内容，而且完全免费，播放也很流畅。',
  },
  {
    name: '李女士',
    role: '追剧达人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20asian%20woman%20in%20her%2020s%2C%20warm%20smile%2C%20clean%20neutral%20background%2C%20soft%20studio%20lighting%2C%20modern%20professional%20look&width=100&height=100&seq=avatar-02&orientation=squarish',
    text: '作为一个追剧狂人，青青草视频的聚合功能简直是神器。新剧更新很及时，画质清晰不卡顿，推荐给所有喜欢看剧的朋友！',
  },
  {
    name: '王同学',
    role: '大学生用户',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20asian%20male%20college%20student%20portrait%2C%20casual%20friendly%20look%2C%20simple%20clean%20background%2C%20natural%20daylight%20photography%2C%20relaxed%20expression&width=100&height=100&seq=avatar-03&orientation=squarish',
    text: '作为学生党，能免费看高清电影真的很香！青青草视频资源丰富，分类清晰，找片特别方便。宿舍看剧就靠它了。',
  },
];

export default function About() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main className="pt-16">
        {/* Hero */}
        <section className="relative w-full h-[300px] md:h-[400px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20interior%20with%20warm%20wooden%20elements%20and%20green%20plants%2C%20soft%20natural%20light%20streaming%20through%20windows%2C%20professional%20creative%20workspace%2C%20calm%20atmosphere%2C%20clean%20design%2C%20warm%20neutral%20tones&width=1920&height=600&seq=about-hero-01&orientation=landscape"
            alt="关于青青草视频"
            title="青青草视频品牌介绍"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
          <div className="relative z-10 text-center px-4">
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-3">关于我们</h1>
            <p className="text-background-200 text-sm md:text-base max-w-lg mx-auto">
              了解青青草视频的品牌故事与发展历程
            </p>
          </div>
        </section>

        <div className="max-w-[1100px] mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', to: '/' },
              { label: '关于我们' },
            ]}
          />

          {/* Brand Introduction */}
          <section className="py-10 md:py-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-6">品牌介绍</h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10">
              <div>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  青青草视频成立于2023年，是国内领先的<strong>影视内容聚合平台</strong>。我们致力于为用户提供<strong>一站式高清免费在线观看</strong>服务，聚合了香蕉视频、红桃视频、91视频、蜜桃视频、樱花视频、糖豆视频、樱桃视频等八大热门影视平台的海量内容。
                </p>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  我们的使命是让每一位用户都能<strong>便捷、免费、流畅</strong>地观看到自己喜欢的影视内容。通过智能CDN加速、多源切换和自适应码率等先进技术，青青草视频为用户提供不缓冲的极致播放体验。
                </p>
                <p className="text-foreground-700 leading-relaxed">
                  青青草视频始终坚持"<strong>用户至上、免费观影</strong>"的理念，不断优化产品体验，丰富内容资源。未来，我们将继续拓展合作平台，引入更多优质内容，让青青草视频成为用户首选的影视观看入口。
                </p>
              </div>
              <div className="bg-background-100 rounded-lg p-6 md:p-8">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-4">平台数据</h3>
                <div className="grid grid-cols-2 gap-4">
                  {[
                    { value: '5000+', label: '影视资源' },
                    { value: '8', label: '合作平台' },
                    { value: '100万+', label: '日活用户' },
                    { value: '99.9%', label: '播放成功率' },
                  ].map((item) => (
                    <div key={item.label} className="text-center p-4 bg-background-50 rounded-lg">
                      <div className="text-2xl font-bold text-primary-600 font-heading">{item.value}</div>
                      <div className="text-xs text-foreground-500 mt-1">{item.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Milestones */}
          <section className="py-10 md:py-14 border-t border-background-200">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-8">发展历程</h2>
            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-primary-200 md:-translate-x-px"></div>
              <div className="space-y-8">
                {milestones.map((item, idx) => (
                  <div
                    key={idx}
                    className={`relative flex flex-col md:flex-row gap-4 md:gap-8 ${
                      idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                    }`}
                  >
                    <div className={`flex-1 ${idx % 2 === 0 ? 'md:text-right' : 'md:text-left'} pl-10 md:pl-0`}>
                      <div className="absolute left-0 md:left-1/2 top-1 w-8 h-8 md:-translate-x-1/2 flex items-center justify-center bg-primary-500 text-background-50 rounded-full z-10">
                        <span className="text-xs font-bold">{idx + 1}</span>
                      </div>
                      <div className="bg-background-50 rounded-lg p-5 border border-background-200/70 ml-4 md:ml-0 md:mx-12">
                        <span className="text-xs text-primary-600 font-medium bg-primary-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                          {item.year}
                        </span>
                        <h3 className="text-base font-semibold text-foreground-900 mt-2 mb-1">{item.title}</h3>
                        <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                      </div>
                    </div>
                    <div className="hidden md:block flex-1"></div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Testimonials */}
          <section className="py-10 md:py-14 border-t border-background-200">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">用户口碑</h2>
            <p className="text-sm text-foreground-500 mb-8">听听用户们怎么说</p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {testimonials.map((item) => (
                <div key={item.name} className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70">
                  <div className="flex items-center gap-3 mb-4">
                    <img
                      src={item.avatar}
                      alt={item.name}
                      className="w-11 h-11 rounded-full object-cover"
                      loading="lazy"
                    />
                    <div>
                      <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                      <div className="text-xs text-foreground-500">{item.role}</div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.text}</p>
                  <div className="flex items-center gap-0.5 mt-3">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Contact */}
          <section className="py-10 md:py-14 border-t border-background-200">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-6">联系我们</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {[
                { icon: 'ri-mail-line', title: '电子邮箱', value: 'service@qingcao-video.com', link: 'mailto:service@qingcao-video.com' },
                { icon: 'ri-wechat-line', title: '微信公众号', value: '青青草视频官方', link: '#' },
                { icon: 'ri-weibo-line', title: '官方微博', value: '@青青草视频', link: '#' },
                { icon: 'ri-customer-service-line', title: '客服热线', value: '400-888-8888', link: 'tel:400-888-8888' },
                { icon: 'ri-map-pin-line', title: '公司地址', value: '北京市朝阳区科技园路88号', link: '#' },
                { icon: 'ri-time-line', title: '工作时间', value: '周一至周日 9:00 - 21:00', link: '#' },
              ].map((item) => (
                <a
                  key={item.title}
                  href={item.link}
                  rel="nofollow"
                  className="flex items-center gap-3 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer no-underline"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                    <i className={`${item.icon} text-primary-600 text-lg`}></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-500 mb-0.5">{item.title}</div>
                    <div className="text-sm font-medium text-foreground-900">{item.value}</div>
                  </div>
                </a>
              ))}
            </div>
          </section>
        </div>
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于青青草视频',
            description: '青青草视频品牌介绍、发展历程、用户口碑与联系方式',
            about: {
              '@type': 'Organization',
              name: '青青草视频',
              foundingDate: '2023',
              description: '聚合香蕉视频、红桃视频、91视频、蜜桃视频等热门影视平台，提供高清免费在线观看服务。',
              contactPoint: {
                '@type': 'ContactPoint',
                contactType: 'customer service',
                email: 'service@qingcao-video.com',
                telephone: '400-888-8888',
                availableLanguage: ['Chinese'],
              },
              address: {
                '@type': 'PostalAddress',
                addressLocality: '北京',
                addressRegion: '朝阳区',
                streetAddress: '科技园路88号',
              },
            },
          }),
        }}
      />
    </>
  );
}